import { render } from "./email-modal.vue?vue&type=template&id=555012f2"
import script from "./email-modal.vue?vue&type=script&lang=js"
export * from "./email-modal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__